<template>
  <v-container fluid grid-list-md class="xn-form pa-0">
    <v-layout wrap>
      <v-flex xs6 md3>
        <router-link to="/companies">
          <v-img :src="url1">
            <span class="top-title">客户总数</span>
            <span class="top-count">{{ dashboard?dashboard.companyCount:0 }}<span class="top-unit">个</span></span>
          </v-img>
        </router-link>
      </v-flex>
      <v-flex xs6 md3>
        <router-link to="/contracts/comp">
          <v-img :src="url2">
            <span class="top-title">合同总数</span>
            <span class="top-count">{{ dashboard?dashboard.contractCount:0 }}<span class="top-unit">份</span></span>
          </v-img>
        </router-link>
      </v-flex>
      <v-flex xs6 md3>
        <router-link to="/documents">
          <v-img :src="url3">
            <span class="top-title">文档总数</span>
            <span class="top-count">{{ dashboard?dashboard.documentCount:0 }}<span class="top-unit">份</span></span>
          </v-img>
        </router-link>
      </v-flex>
      <v-flex xs6 md3>
        <v-img :src="url4">
          <span class="top-title">今日缴费提醒</span>
          <span class="top-count">{{ dashboard?dashboard.dueScheduleTodayCount:0 }}<span
            class="top-unit">个</span></span>
        </v-img>
      </v-flex>
      <v-flex xs12 lg9 order-xs1 order-md1 order-lg1>
        <div class="wrapper">
          <span class="w-title">新增客户统计</span>
          <span class="right">
            <v-btn
              color="info"
              small
              :outline="companiesSelected!==7"
              class="btn-date-filter"
              @click="changeCompanyDate(7)"
            >7天</v-btn>
            <v-btn
              color="info"
              small
              :outline="companiesSelected!==30"
              class="btn-date-filter"
              @click="changeCompanyDate(30)"
            >30天</v-btn>
          </span>
          <div id="chart1" style="height: 240px;"></div>
        </div>
      </v-flex>
      <v-flex xs12 md9 lg3 order-xs3 order-md3 order-lg2>
        <div class="wrapper">
          <span class="w-title">客户地区分布TOP5</span>
          <div id="chart3" style="height: 240px;"></div>
        </div>
      </v-flex>
      <v-flex xs12 lg9 order-xs2 order-md2 order-lg3>
        <div class="wrapper">
          <span class="w-title">新增合同统计</span>
          <span class="right">
            <v-btn
              color="info"
              small
              :outline="contractsSelected!==7"
              class="btn-date-filter"
              @click="changeContractDate(7)"
            >7天</v-btn>
            <v-btn
              color="info"
              small
              :outline="contractsSelected!==30"
              class="btn-date-filter"
              @click="changeContractDate(30)"
            >30天</v-btn>
          </span>
          <div id="chart2" style="height: 240px;"></div>
        </div>
      </v-flex>
      <v-flex xs12 md3 order-xs4 order-md4 order-lg4>
        <div class="wrapper">
          <span class="w-title">待办事项</span>

          <div style="height: 240px;" class="pt-3 pl-2">
            <template v-if="dashboard.tasks&&dashboard.tasks.length>0">
              <router-link
                v-for="task in dashboard.tasks"
                :key="task.taskId"
                :to="`tasks/${task.taskId}/detail`"
                class="task-item"
                :class="task.progress==='已创建'?'step1':'step2'"
              >
                <span class="task-title">{{ task.description }}</span>
                <span class="task-date">{{ dateFormat(new Date(task.lastUpdateDate), "YYYY-MM-DD") }}</span>
              </router-link>
            </template>
            <template v-if="dashboard.tasks&&dashboard.tasks.length===0">
              <span>暂无待办事项</span>
            </template>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import url1 from '../assets/p1.png';
  import url2 from '../assets/p2.png';
  import url3 from '../assets/p3.png';
  import url4 from '../assets/p4.png';
  import axios from '../axios';
  import {dateFormat} from "vue-filter-date-format";

  import echarts from 'echarts/lib/echarts';
  // 引入柱状图
  import 'echarts/lib/chart/line';
  import 'echarts/lib/chart/bar';
  // 引入提示框和标题组件
  import 'echarts/lib/component/tooltip';
  //import 'echarts/lib/component/title';


  export default {
    data: () => ({
      url1: url1,
      url2: url2,
      url3: url3,
      url4: url4,
      chart1: null,
      chart2: null,
      chart3: null,
      dashboard: {},
      companiesSelected: 7,
      contractsSelected: 7
    }),
    computed: {
      companyIndex() {
        return this.dashboard.newCompanyCounts.length - (this.companiesSelected + 1);
      },
      contractIndex() {
        return this.dashboard.newContractCounts.length - (this.contractsSelected + 1);
      }
    },
    methods: {
      dateFormat: dateFormat,
      changeCompanyDate(date) {
        this.companiesSelected = date;
        this.chart1.setOption({
          xAxis: {
            data: this.dashboard.newCompanyCounts
              .filter((item, index) => index > this.companyIndex)
              .map(item => item.date.substr(5)),
          },
          series: {
            data: this.dashboard.newCompanyCounts
              .filter((item, index) => index > this.companyIndex)
              .map(item => item.count),
          }
        })
      },
      changeContractDate(date) {
        this.contractsSelected = date;
        this.chart2.setOption({
          xAxis: {
            data: this.dashboard.newContractCounts
              .filter((item, index) => index > this.contractIndex)
              .map(item => item.date.substr(5)),
          },
          series: {
            data: this.dashboard.newContractCounts
              .filter((item, index) => index > this.contractIndex)
              .map(item => item.count),
          }
        })
      },
      initChart1() {
        // 基于准备好的dom，初始化echarts实例
        this.chart1 = echarts.init(document.getElementById('chart1'));
        // 绘制图表
        this.chart1.setOption({
          tooltip: {},
          xAxis: {
            data: this.dashboard.newCompanyCounts
              .filter((item, index) => index > this.companyIndex)
              .map(item => item.date.substr(5)),
            boundaryGap: false,
          },
          yAxis: {
            type: 'value',
            name: '数量(个)',
            minInterval: 1,
            boundaryGap: [0, 0.1],
            splitLine: {
              lineStyle: {
                color: ['#ccc'],
                width: 1,
                type: 'solid',
                opacity: 0.2
              }
            },
          },
          series: {
            type: 'line',
            smooth: true,
            data: this.dashboard.newCompanyCounts
              .filter((item, index) => index > this.companyIndex)
              .map(item => item.count),
            lineStyle: {
              color: '#BA63FF'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(182,77,255,0.62)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(176,78,255,0.15)' // 100% 处的颜色
                }]
              },
              opacity: 0.3
            }
          }
        });

        window.addEventListener("resize", () => {
          this.chart1.resize();
        });
      },
      initChart2() {
        // 基于准备好的dom，初始化echarts实例
        this.chart2 = echarts.init(document.getElementById('chart2'));
        // 绘制图表
        this.chart2.setOption({
          tooltip: {},
          xAxis: {
            data: this.dashboard.newContractCounts
              .filter((item, index) => index > this.contractIndex)
              .map(item => item.date.substr(5)),
            boundaryGap: false,
          },
          yAxis: {
            type: 'value',
            name: '数量(个)',
            minInterval: 1,
            boundaryGap: [0, 0.1],
            splitLine: {
              lineStyle: {
                color: ['#ccc'],
                width: 1,
                type: 'solid',
                opacity: 0.2
              }
            },
          },
          series: {
            type: 'line',
            smooth: true,
            data: this.dashboard.newContractCounts
              .filter((item, index) => index > this.contractIndex)
              .map(item => item.count),
            lineStyle: {
              color: '#429CFF'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(82,179,227,0.62)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(82,179,227,0.15)' // 100% 处的颜色
                }]
              },
              opacity: 0.3
            }
          }
        });

        window.addEventListener("resize", () => {
          this.chart2.resize();
        });
      },
      initChart3() {
        // 基于准备好的dom，初始化echarts实例
        this.chart3 = echarts.init(document.getElementById('chart3'));
        // 绘制图表
        this.chart3.setOption({
          tooltip: {},
          xAxis: {
            data: this.dashboard.provinceCounts.map((item) => item.province)
          },
          yAxis: {
            type: 'value',
            name: '数量(个)',
            minInterval: 1,
            boundaryGap: [0, 0.1],
            splitLine: {
              lineStyle: {
                color: ['#ccc'],
                width: 1,
                type: 'solid',
                opacity: 0.2
              }
            },
          },
          series: [{
            type: 'bar',
            data: this.dashboard.provinceCounts.map(item => item.count),
            barWidth: 20,
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    '#C1232B', '#D7504B', '#FE8463', '#F4E001', '#C6E579'
                  ];
                  return colorList[params.dataIndex]
                }
              }
            }
          }],
        });

        window.addEventListener("resize", () => {
          this.chart3.resize();
        });
      },
    },
    created() {

      axios
        .get("/dashboard")
        .then(response => {
          this.dashboard = response.data;
          this.initChart1();
          this.initChart2();
          this.initChart3();
        })
        .catch(reason => {
          this.$confirm(reason.response.data.message, {
            buttonFalseText: null
          });
        });
    }
  };
</script>

<style scoped>
  .top-title {
    color: #fff;
    font-size: 24px;
    position: absolute;
    top: 25px;
    left: 28px;
  }

  .top-count {
    color: #fff;
    font-size: 44px;
    position: absolute;
    bottom: 25px;
    left: 28px;
  }

  .top-unit {
    color: #fff;
    font-size: 20px;
  }

  .task-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    position: relative;
    text-decoration: none;
  }

  .task-item:before {
    content: '';
    width: 6px;
    height: 6px;
    left: -10px;
    border-radius: 50%;
    position: absolute;
  }

  .task-item.step1:before {
    background: #FF4848;
  }

  .task-item.step2:before {
    background: #2085F5;
  }

  .task-item.step3:before {
    background: #00C000;
  }

  .task-title {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #555;
  }

  .task-date {
    flex: 0 0 85px;
    color: #aaa;
    text-align: right;
  }

  .btn-date-filter {
    width: 57px;
    margin: 0 3px !important;
  }

  @media screen and (min-width: 960px) and (max-width: 1300px) {
    .top-title {
      font-size: 16px;
      top: 16px;
      left: 14px;
    }

    .top-count {
      font-size: 22px;
      left: 14px;
    }

    .top-unit {
      font-size: 10px;
    }
  }

  @media screen and (max-width: 760px) {
    .top-title {
      font-size: 16px;
      top: 16px;
      left: 14px;
    }

    .top-count {
      font-size: 22px;
      left: 14px;
      bottom:15px;
    }

    .top-unit {
      font-size: 10px;
    }
  }
</style>
